export const INSTRUCTOR_COLUMNS = [
  { id: "instructor", label: "Instructor", alwaysVisible: true, defaultVisible: true },
  { id: "skills", label: "Skills", alwaysVisible: false, defaultVisible: true },
  { id: "upcoming_sessions_count", label: "Upcoming sessions", alwaysVisible: false, defaultVisible: true },
  { id: "all_time_sessions_count", label: "All-time sessions", alwaysVisible: false, defaultVisible: true },
  { id: "created_at", label: "Added", alwaysVisible: false, defaultVisible: true },
  { id: "title", label: "Title", alwaysVisible: false, defaultVisible: false },
  { id: "email", label: "Email", alwaysVisible: false, defaultVisible: false },
];

export const SORT_OPTIONS = [
  { value: "name asc", label: "Name (A-Z)" },
  { value: "name desc", label: "Name (Z-A)" },
  { value: "created_at desc", label: "Newest First" },
  { value: "created_at asc", label: "Oldest First" },
  { value: "title asc", label: "Title (A-Z)" },
];
